import {
  USER_CHECK,
  USER_CHECK_FAILURE,
  USER_CHECK_SUCCESS,
  USER_HIDE_SUCCESS,
  USER_LOADING_HIDE,
  USER_LOADING_SHOW,
  USER_SHOW_SUCCESS,
  USER_SIGN_IN,
  USER_SIGN_IN_FAILURE,
  USER_SIGN_OUT,
  USER_SIGN_OUT_FAILURE,
  USER_UPDATE_BALANCE,
  USER_UPDATE_DATA,
  USER_UPDATE_PASSWORD,
} from "@shared/constants";
import { serverErrorHandler } from "@shared/reducers/error";
import { filterService } from "@shared/services/query-filter-service/query-filter-service";
import { userWatchActivityService } from "@shared/services/user-watch-activity-service/user-watch-activity-service";
import {
  SAGA_DELAY_SIZE,
  checkResponse,
  isResponseError,
  post,
} from "@shared/utils/server";
import { all, call, delay, fork, put, takeLatest } from "redux-saga/effects";

export function* updateBalance() {
  try {
    const response = yield call(post, {
      method: "Auth.user",
      args: {},
    });

    checkResponse(response);

    yield put({
      type: USER_CHECK_SUCCESS,
      payload: response[0],
    });
  } catch (error) {
    yield put({
      type: USER_CHECK_FAILURE,
      payload: serverErrorHandler(error.message),
    });
  }
}

export function* changePassword(action) {
  try {
    yield put({ type: USER_LOADING_SHOW });
    const { oldPassword, newPassword } = action.payload;
    yield call(post, {
      method: "Auth.changePassword",
      args: { oldPassword, newPassword },
    });

    yield put({ type: USER_LOADING_HIDE });
    yield put({ type: USER_SHOW_SUCCESS });
    yield delay(SAGA_DELAY_SIZE);
    yield put({ type: USER_HIDE_SUCCESS });
    // eslint-disable-next-line no-empty
  } catch {
    // Error catch
  }
}

export function* updateUserData(action) {
  try {
    yield put({ type: USER_LOADING_SHOW });
    const { name, email, phone } = action.payload;
    const response = yield call(post, {
      method: "Auth.userUpdate",
      args: { name, email, phone },
    });

    yield put({ type: USER_CHECK_SUCCESS, payload: response[0] });
    yield put({ type: USER_LOADING_HIDE });
    yield put({ type: USER_SHOW_SUCCESS });
    yield delay(SAGA_DELAY_SIZE);
    yield put({ type: USER_HIDE_SUCCESS });
  } catch (error) {
    yield put({
      type: USER_CHECK_FAILURE,
      payload: serverErrorHandler(error?.message),
    });
  }
}

export function* checkUser() {
  try {
    const response = yield call(post, {
      method: "Auth.user",
      args: { isUserActive: userWatchActivityService.isUserActive },
    });

    if (response[0] === null) {
      setTimeout(() => {
        filterService.removeFilters();
      }, 600);
    }

    if (isResponseError(response)) {
      yield put({
        type: USER_CHECK_FAILURE,
        payload: serverErrorHandler(response),
      });
    } else {
      yield put({
        type: USER_CHECK_SUCCESS,
        payload: response[0],
      });
    }
  } catch (error) {
    yield put({
      type: USER_CHECK_FAILURE,
      payload: serverErrorHandler(error?.message),
    });
  }
}

export function* signIn(action) {
  try {
    yield put({ type: USER_LOADING_SHOW });
    const { username, password } = action.payload;

    const response = yield call(post, {
      method: "Auth.login",
      args: {
        login: username,
        password: password,
        remember: true,
      },
    });

    if (response instanceof Error) {
      put({
        type: USER_SIGN_IN_FAILURE,
        payload: "boilerplate.components.Popup.AuthError",
      });
    }

    checkResponse(response);
    window.location.reload();
  } catch (error) {
    yield all([
      put({ type: USER_LOADING_HIDE }),
      put({ type: USER_SIGN_IN_FAILURE, payload: error }),
    ]);
  }
}

export function* signOut() {
  try {
    const response = yield post({ method: "Auth.logout", args: {} });
    checkResponse(response);
    window.location.reload();
  } catch (error) {
    yield put({
      type: USER_SIGN_OUT_FAILURE,
      payload: error,
    });
  }
}

function* watchUpdateBalance() {
  yield takeLatest(USER_UPDATE_BALANCE, updateBalance);
}

function* watchUserUpdateData() {
  yield takeLatest(USER_UPDATE_DATA, updateUserData);
}

function* watchUserUpdatePassword() {
  yield takeLatest(USER_UPDATE_PASSWORD, changePassword);
}

function* watchCheckUser() {
  yield takeLatest(USER_CHECK, checkUser);
}

function* watchUserSignIn() {
  yield takeLatest(USER_SIGN_IN, signIn);
}

function* watchUserSignOut() {
  yield takeLatest(USER_SIGN_OUT, signOut);
}

export default function* user() {
  yield all([
    fork(watchUpdateBalance),
    fork(watchUserUpdatePassword),
    fork(watchUserUpdateData),
    fork(watchCheckUser),
    fork(watchUserSignIn),
    fork(watchUserSignOut),
  ]);
}
